import { AbstractModel, isNullOrUndefined, DateFormatConstants } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import moment from 'moment-timezone';

@inheritSerialization(AbstractModel)
export class HolidaySchedule extends AbstractModel {
  @autoserialize
  transitProgramId: number;

  @autoserialize
  name: string;

  @autoserialize
  operational: boolean;

  @autoserializeAs(Date)
  date: Date;

  @autoserialize
  startTime: string;

  @autoserialize
  endTime: string;

  static OnSerialized(instance: HolidaySchedule, json: any): void {
    if (!isNullOrUndefined(instance.date)) {
      json.date = moment(instance.date).format(DateFormatConstants.ISO_LOCAL_DATE);
    }
  }

  static OnDeserialized(instance: HolidaySchedule, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['date'])) {
      instance.date = moment(json['date']).toDate();
    }
  }
}
